const hash = require('object-hash');
const constants = require('./constants');
const uuid = require('uuid');

class Segment {
  constructor(id, coordinates, olr, attributes, flag) {
    this._id = id;
    this._flag = flag;
    this._coordinates = [];
    this._timeFrameString = "";

    if (coordinates) {
      // eslint-disable-next-line max-len
      this._coordinates = coordinates.filter(coordinate => coordinate.getX() !== 0 && coordinate.getY() !== 0);
    }
    this._olr = olr;
    this._attributes = {};

    if(attributes) {
      Object.keys(attributes).forEach(attributeKey => {
        this._attributes[attributeKey] = attributes[attributeKey];
      });
    }

    this.updateHash();
  }

  updateHash() {
    //let newKey = uuid.v4();
    //this._hash = hash(newKey)
    this._hash = uuid.v4();
  }

  get id() {
    return this._id;
  }

  get coordinates() {
    return this._coordinates;
  }

  get coordinatesString() {
    let coordinatesString = this._coordinates.map(coordinate => `${coordinate.getX()},${coordinate.getY()}`).join(',');

    if (coordinatesString === '') {
      coordinatesString = '0,0';
    }

    return coordinatesString;
  }

  get olr() {
    return this._olr;
  }

  set olr(value) {
    this._olr = value;
  }

  get attributes() {
    return this._attributes;
  }

  get hash() {
    return this._hash;
  }

  get flag() {
    return this._flag;
  }

  get attributesCount() {
    return Object.keys(this._attributes).length;
  }

  get timeFrameString() {
    return this._timeFrameString;
  }

  set timeFrameString(timeFrame) {
    this._timeFrameString = timeFrame;
  }

  getAttributeByName(name) {
    if (!Object.prototype.hasOwnProperty.call(this._attributes, name)) {
      return null;
    }

    return this._attributes[name];
  }

  getModifyStreetAttributeByName(name) {
    if(!Object.prototype.hasOwnProperty(this._attributes.modified_street, name)) {
      return null;
    }

    return this._attributes.modified_street[name];
  }

  getIsAttributesEqualTo(otherAttributes) {
    if (Object.keys(this._attributes).length !== Object.keys(otherAttributes).length) return false;

    let equals = true;

    Object.keys(this._attributes).forEach((name) => {
      if (!Object.prototype.hasOwnProperty.call(otherAttributes, name)
        || otherAttributes[name].toString() !== this.getAttributeByName(name).toString()) {
        equals = false;
      }
    });

    return equals;
  }

  getIsModifiedStreetAttributesEqualTo(otherAttributes) {
    if (Object.keys(this._attributes.modified_street).length !== Object.keys(otherAttributes).length) return false;

    let equals = true;

    Object.keys(this._attributes.modified_street).forEach((name) => {
      if (!Object.prototype.hasOwnProperty.call(otherAttributes, name)
        || otherAttributes[name] !== this.getModifyStreetAttributeByName(name)) {
        equals = false;
      }
    });

    return equals;
  }

  set coordinates(value) {
    this._coordinates = value;
  }

  set attributes(value) {
    this._attributes = value;
  }

  set flag(value) {
    this._flag = value;
  }

  set hash(value) {
    this._hash = value;
  }

  set type(type) {
    if (type === constants.SEGMENT_CLOSE && Object.prototype.hasOwnProperty.call(this._attributes, 'mod_restriction')) {

      delete this._attributes.mod_restriction;
      delete this._attributes.truckattributes;
      delete this._attributes.modified_street;
      delete this._attributes.priority;
      delete this._attributes.detourEditor_deletedByUser;
      delete this._attributes.ovld_RS;
      delete this._attributes.Delay;
      delete this._attributes.NewSpeed;

      this._attributes.SegmentType = constants.SEGMENT_TYPE_BLOCK;

    }if (type === constants.SEGMENT_CLOSE) {

      delete this._attributes.mod_restriction;
      delete this._attributes.truckattributes;
      delete this._attributes.modified_street;
      delete this._attributes.priority;
      delete this._attributes.detourEditor_deletedByUser;
      delete this._attributes.ovld_RS;
      delete this._attributes.Delay;
      delete this._attributes.NewSpeed;

      this._attributes.SegmentType = constants.SEGMENT_TYPE_BLOCK;

    } else if (type === constants.SEGMENT_UNBLOCK) {

      this._attributes.mod_restriction = 'unblock';
      delete this._attributes.truckattributes;
      delete this._attributes.modified_street;
      delete this._attributes.priority;
      delete this._attributes.detourEditor_deletedByUser;
      delete this._attributes.ovld_RS;
      delete this._attributes.Delay;
      delete this._attributes.NewSpeed;

      this._attributes.SegmentType = constants.SEGMENT_TYPE_UNBLOCK;

    } else if(type === constants.SEGMENT_PENALIZE) {

      delete this._attributes.mod_restriction;
      delete this._attributes.truckattributes;
      delete this._attributes.modified_street;
      delete this._attributes.detourEditor_deletedByUser;
      delete this._attributes.ovld_RS;
      this._attributes.priority = constants.PENALIZE_DEFAULT_VALUE;
      delete this._attributes.Delay;
      delete this._attributes.NewSpeed;

      this._attributes.SegmentType = constants.SEGMENT_TYPE_AVOID;

    } else if(type === constants.SEGMENT_PRIORITIZE) {

      delete this._attributes.mod_restriction;
      delete this._attributes.truckattributes;
      delete this._attributes.modified_street;
      delete this._attributes.detourEditor_deletedByUser;
      delete this._attributes.ovld_RS;
      this._attributes.priority = constants.PRIORITIZE_DEFAULT_VALUE;
      delete this._attributes.Delay;
      delete this._attributes.NewSpeed;

      this._attributes.SegmentType = constants.SEGMENT_TYPE_PRIORITZE;

    } else if(type === constants.SEGMENT_TYPE_MODIFIED_SPEED) {

      delete this._attributes.mod_restriction;
      delete this._attributes.truckattributes;
      delete this._attributes.modified_street;
      delete this._attributes.detourEditor_deletedByUser;
      delete this._attributes.ovld_RS;
      delete this._attributes.priority;
      delete this._attributes.start;
      delete this._attributes.end;
      delete this._attributes.TimeDomain;

      this._attributes.SegmentType = constants.SEGMENT_TYPE_MODIFIED_SPEED;

    } else if(type === constants.SEGMENT_TRUCK_ATTRIBUTES) {

      delete this._attributes.mod_restriction;
      delete this._attributes.truckattributes;
      delete this._attributes.modified_street;
      delete this._attributes.priority;
      delete this._attributes.detourEditor_deletedByUser;
      delete this._attributes.ovld_RS;
      this._attributes.truckattributes = constants.SEGMENT_TRUCK_ATTRIBUTES;
      delete this._attributes.Delay;
      delete this._attributes.NewSpeed;

      this._attributes.SegmentType = constants.SEGMENT_TYPE_MODIFIED_TRUCKATTRIBUTES;

    }  else if(type === constants.SEGMENT_MODIFIED_STREET) {

      delete this._attributes.mod_restriction;
      delete this._attributes.truckattributes;
      delete this._attributes.priority;
      delete this._attributes.detourEditor_deletedByUser;
      delete this._attributes.ovld_RS;
      delete this._attributes.Delay;
      delete this._attributes.NewSpeed;

      this._attributes.SegmentType = constants.SEGMENT_TYPE_NEW_STREET;

    } else if(type === constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL) {
      delete this._attributes.modified_street;
      delete this._attributes.truckattributes;
      delete this._attributes.priority;
      delete this._attributes.start;
      delete this._attributes.end;
      delete this._attributes.TimeDomain;
      delete this._attributes.Delay;
      delete this._attributes.NewSpeed;

      //this._attributes.detourEditor_deletedByUser = true;
      this._attributes.ovld_RS = 4095;
      this._attributes.SegmentType = constants.SEGMENT_TYPE_EXPLICIT_DELETED_ORIGINAL;
    } else if(type === constants.SEGMENT_TYPE_ADDED_MANEUVER) {

      delete this._attributes.modified_street;
      delete this._attributes.truckattributes;
      delete this._attributes.priority;
      delete this._attributes.detourEditor_deletedByUser;
      delete this._attributes.ovld_RS;
      delete this._attributes.Delay;
      delete this._attributes.NewSpeed;

      this._attributes.modify_MANEUVERS = 'add';
      this._attributes.SegmentType = constants.SEGMENT_TYPE_ADDED_MANEUVER;
    } else { // default case
      delete this._attributes.mod_restriction;
    }

    this.updateHash();
  }

  set direction(direction) {
    this._attributes.direction = direction;
  }

  get type() {
    if(Object.prototype.hasOwnProperty.call(this._attributes, 'SegmentType')) {
      switch(this._attributes["SegmentType"]) {
        case constants.SEGMENT_TYPE_AVOID:
          return constants.SEGMENT_PENALIZE;

        case constants.SEGMENT_TYPE_PRIORITZE:
          return constants.SEGMENT_PRIORITIZE;

        case constants.SEGMENT_TYPE_BLOCK:
          return constants.SEGMENT_CLOSE;

        case constants.SEGMENT_TYPE_UNBLOCK:
          return constants.SEGMENT_UNBLOCK;

        case constants.SEGMENT_TYPE_NEW_STREET:
          return constants.SEGMENT_MODIFIED_STREET;

        case constants.SEGMENT_TYPE_MODIFIED_TRUCKATTRIBUTES:
          return constants.SEGMENT_TRUCK_ATTRIBUTES;

        case constants.SEGMENT_TYPE_DELETED_MANEUVER:
          return constants.SEGMENT_TURN_RESTRICTION;
        /*
        case constants.SEGMENT_TYPE_CUT_POINT:
          break;
        case constants.SEGMENT_TYPE_DELETED_ORIGINAL:
          break;
        case constants.SEGMENT_TYPE_DISSECTED_STREET:
          break;
        case constants.SEGMENT_TYPE_DIVIDED_STREET:
          break;
        case constants.SEGMENT_TYPE_MODIFIED_RESTRICTIONS:
          break;*/
        default:
          return this._attributes.SegmentType;
      }
    }



    /*
    if (Object.prototype.hasOwnProperty.call(this._attributes, 'mod_restriction') && this._attributes.mod_restriction === 'unblock') {
      return constants.SEGMENT_UNBLOCK;
    }

    if (Object.prototype.hasOwnProperty.call(this._attributes, 'modify_MANEUVERS') && this._attributes.modify_MANEUVERS === 'delete') {
      return constants.SEGMENT_TURN_RESTRICTION;
    }

    if (Object.prototype.hasOwnProperty.call(this._attributes, 'priority') && this._attributes.priority >= 1) {
      return constants.SEGMENT_PRIORITIZE;
    }

    if (Object.prototype.hasOwnProperty.call(this._attributes, 'priority') && this._attributes.priority < 1) {
      return constants.SEGMENT_PENALIZE;
    }

    if(Object.prototype.hasOwnProperty.call(this._attributes, 'truckattributes')) {
      return constants.SEGMENT_TRUCK_ATTRIBUTES;
    }

    if(Object.prototype.hasOwnProperty.call(this._attributes, 'modified_street') || this.olr === 'Geometry') {
      return constants.SEGMENT_MODIFIED_STREET;
    }

    return constants.SEGMENT_CLOSE;
    */
  }

  clone() {
    const coordinates = this._coordinates.map(coordinate => new window.IWCoordinate(
      coordinate.getX(),
      coordinate.getY(),
      window.IWCoordinate.WGS84,
    ));

    const attributes = {};
    Object.keys(this._attributes).forEach((key) => {
      attributes[key] = this._attributes[key];
    });

    return new Segment(this._id, coordinates, this._olr, attributes, this._olr);
  }

  serialize() {
    const segmentPlainObject = {
      id: this._id,
      flag: this._flag,
      coordinates: this._coordinates.map(coordinate => [coordinate.getX(), coordinate.getY()]),
      olr: this._olr,
      attributes: this._attributes,
      hash: this._hash,
    };

    return JSON.stringify(segmentPlainObject);
  }

  static deserialize(segmentRaw) {
    const segment = JSON.parse(segmentRaw);
    const coordinates = segment.coordinates.map(coordinate => new IWCoordinate(
      coordinate[0],
      coordinate[1],
      window.IWCoordinate.WGS84,
    ));

    if(segment.attributes.detourEditor_hasArrowSet) {
      const arrowCoordinates = segment.attributes.detourEditor_turnArrowCoords.map(coordinate => new IWCoordinate(
        coordinate._x,
        coordinate._y,
        window.IWCoordinate.WGS84,
      ));

      segment.attributes.detourEditor_turnArrowCoords = arrowCoordinates;
    }

    return new Segment(segment.id, coordinates, segment.olr, segment.attributes, segment.flag);
  }
}

module.exports = Segment;
